<template>
	<div>
		<!-- The shell owns the header and the surface tabs; each routed view
		     supplies its own page padding beneath them. -->
		<div class="container-fluid px-4 pt-4">
			<div class="d-flex justify-content-between align-items-center mb-4">
				<div>
					<h1 class="mb-0">Inventory</h1>
					<p class="text-muted mb-0">
						Your district's pesticide products, stock, containers, checks, and
						custom mixes.
					</p>
				</div>
			</div>

			<!-- Section navigation: the district's own inventory surfaces. The
			     shared pesticide catalog is reference material rather than district
			     stock, so it is not a tab here — the Products page's "View full
			     catalog" button is its entrance. The section shell renders the
			     strip. -->
			<SectionTabs class="inventory-tabs" :tabs="tabs" />
		</div>

		<router-view />
	</div>
</template>

<script setup lang="ts">
import SectionTabs from "@/components/common/SectionTabs.vue";

// Root is the inventory section shell: it renders the surface tabs (nav lives
// here, in one place) and the routed view beneath them. It imports no view
// itself — the router supplies each surface.
const tabs = [
	{ to: "/_/inventory", label: "Inventory", icon: "bi-box-seam" },
	{ to: "/_/inventory/products", label: "Products", icon: "bi-droplet-fill" },
	{
		to: "/_/inventory/interventions",
		label: "Interventions",
		icon: "bi-tools",
	},
	{
		to: "/_/inventory/receive",
		label: "Receive",
		icon: "bi-box-arrow-in-down",
	},
	{
		to: "/_/inventory/movements",
		label: "Movements",
		icon: "bi-arrow-left-right",
	},
	{ to: "/_/inventory/containers", label: "Containers", icon: "bi-bucket" },
	{ to: "/_/inventory/locations", label: "Locations", icon: "bi-diagram-3" },
	{ to: "/_/inventory/checks", label: "Checks", icon: "bi-clipboard-check" },
	{
		to: "/_/inventory/reconciliation",
		label: "Reconciliation",
		icon: "bi-exclamation-diamond",
	},
	{ to: "/_/inventory/units", label: "Units", icon: "bi-rulers" },
	{ to: "/_/inventory/mixes", label: "Mixes", icon: "bi-droplet-half" },
];
</script>

<style scoped>
/* Eleven surfaces in one strip: the shared SectionTabs sizes pills for the
   four-tab sections, which needs roughly 1400px for twelve. Scope a denser size
   to this section only, and let the strip wrap when the column is narrower — the
   labels stay whole and every surface stays reachable without a scroller. */
.inventory-tabs :deep(.nav-link) {
	font-size: 0.75rem;
	padding: 0.3rem;
	white-space: nowrap;
}
</style>
